// AboutDialog.tsx — About ConstructiVision Web Beta

import DialogBase from './DialogBase';

export default function AboutDialog() {
  return (
    <DialogBase title="About ConstructiVision Web" cancelLabel="" okLabel="Close">
      <div className="about-box">
        <div className="about-logo">CV</div>
        <h2 className="about-name">ConstructiVision Web</h2>
        <p className="about-version">CV-Web V1.0</p>
        <p className="about-desc">
          Tilt-Up Concrete Panel Detailing — Progressive Web Application
        </p>
        <p className="about-desc">
          Faithful web port of the AutoCAD AutoLISP plugin. All panel data
          is stored locally in your browser (IndexedDB). DXF export
          produces AutoCAD R2000-compatible files.
        </p>
        <p className="about-copy">
          © ConstructiVision. All rights reserved.
        </p>
      </div>
    </DialogBase>
  );
}
